import { Box, Container, Typography, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import React from 'react';
import { Link } from 'react-router-dom';
import { useUser } from '../hooks/useUser.ts';
import UserProfile from './UserProfile.tsx';

const Header: React.FC = () => {
  const { data: user } = useUser();
  const theme = useTheme();
  
  return (
    <Box 
      component="header"
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        background: 'rgba(255, 255, 255, 0.98)',
        borderBottom: '1px solid',
        borderColor: 'rgba(0, 0, 0, 0.06)',
        backdropFilter: 'blur(10px)',
        zIndex: 1100,
        py: 1.5,
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.03)'
      }}
    >
      <Container maxWidth="xl">
        <Box 
          sx={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            width: '100%',
          }}
        >
          <Typography 
            component={Link}
            to="/"
            variant="h6"
            fontWeight="600"
            sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              fontSize: { xs: '1.1rem', sm: '1.25rem' },
              textDecoration: 'none',
              color: 'inherit',
              '&:hover': {
                color: 'primary.main',
                cursor: 'pointer'
              },
              transition: 'color 0.2s ease'
            }}
          >
            <Box 
              component={motion.span}
              animate={{ 
                rotate: [0, 10, -10, 0],
                transition: { repeat: Infinity, duration: 5, repeatType: 'loop' }
              }}
              sx={{ 
                mr: 1,
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <img src="/apple-icon-180x180.png" alt="Logo" style={{ width: '2rem', height: '2rem' }} />
            </Box>
            <Box component="span">
              Birthday Planner
            </Box>
          </Typography>
          
          {user && (
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <UserProfile user={user} />
            </motion.div>
          )}
        </Box>
      </Container>
    </Box>
  );
};

export default Header; 